var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"options":_vm.dicItems,"props":{
    checkStrictly: true,
    expandTrigger: 'hover',
    emitPath: false,
  },"clearable":!_vm.column.required,"placeholder":_vm.placeholder},on:{"change":_vm.change},model:{value:(_vm.selVal),callback:function ($$v) {_vm.selVal=$$v},expression:"selVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }